export default "__VITE_ASSET__203da068__";